import theme from './theme/ja_JP';
import profile from './profile/ja_JP';
import member from './member/ja_JP';
import organization from './organization/ja_JP';
import console from './console/ja_JP';
import aws from './aws/ja_JP';
import activity from './activity/ja_JP';
export default {
  ...theme,
  ...profile,
  ...console,
  ...organization,
  ...member,
  ...aws,
  ...activity,
};
